import { render, staticRenderFns } from "./ratePlan.vue?vue&type=template&id=2381463e"
import script from "./ratePlan.vue?vue&type=script&lang=js"
export * from "./ratePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports